import React from 'react';
import { BrowserRouter as Router, Routes, Route, BrowserRouter } from 'react-router-dom';
import Onboarding from './Pages/Onboarding';
import Home from './Pages/Home';
import Login from './Pages/Login';
import Otp from './Pages/Otp';
import Booking from './Pages/Booking';
import Ticket from './Pages/Ticket';
import Map from './Pages/Map';
import Notifications from './Pages/Notifications';
import Error404 from './Pages/Error404';
import Rating from './Pages/Rating';


const RouteUrls = () => {
    return ( 
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Onboarding />} />
                <Route path="*" element={<Error404 />} />
                <Route path="/home" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/otp" element={<Otp />} />
                <Route path='/booking' element={<Booking />}/>
                <Route path='/ticket' element={<Ticket />}/>
                <Route path='/map' element={<Map />}/>
                <Route path='/notifications' element={<Notifications />}/>
                <Route path='/rating' element={<Rating />}/>
            </Routes>
        </BrowserRouter>
     );
}
 
export default RouteUrls;